export enum IDaysWeek {
  permissionMonday = 'permissionMonday',
  permissionTuesday = 'permissionTuesday',
  permissionWednesday = 'permissionWednesday',
  permissionThursday = 'permissionThursday',
  permissionFriday = 'permissionFriday',
  permissionSaturday = 'permissionSaturday',
  permissionSunday = 'permissionSunday',
}
